export default __webpack_public_path__ + "static/media/bookstore_videos.e1268b0b.png";